export default {"src":"/_next/static/media/icon-openinnew.97eded9f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};